module.exports = __webpack_public_path__ + "img/play.97a8783a.svg";